<template>
    <!-- <div :class='this.class' v-if="hasSubmenu"> -->
    <router-link :to='this.link' class="navbar-link navbar-item has-dropdown" :class="{'router-link-active' : hasActiveSub(this.link)}" v-if="hasSubmenu">{{ title | uppercase }}
        <div class="navbar-dropdown" v-if="hasSubmenu">
             <router-link class="navbar-item" v-if="hasSubmenu" v-for="item in this.submenu" :key='item.id' :to="{ name: item.name }">{{ item.id}}</router-link>
        </div>
    </router-link>
    <!-- </div> -->
    <router-link :to='this.link' class='navbar-item' v-else>
        {{ title | uppercase }}
    </router-link>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'navbaritem',
  props: ['title', 'link','sub'],
  data(){
     
      return{
          class: '',
          hasSubmenu:'false',
          submenu: ''
      }
  },
  created(){
      this.hasSubmenu = (this.sub) ? true : false;
      this.submenu = this.sub;
      this.class= (!this.hasSubmenu) ? "navbar-item" : "navbar-item has-dropdown";
      
  },
  filters: {
      uppercase: function (value) {
	    return value.toUpperCase()
    }
  },
  computed:{
      ...mapGetters({
      viewMode : "system/displayType"
    })
  },
  methods:{
      hasActiveSub(activeLink){
          let active = false;
          if(this.$route.name == "Ausstellung" && activeLink == "/ueber-uns"){
              active = true
          }else if(activeLink == "/leistungen/ueberblick") {
                this.$route.matched.find( item => {
                    if(item.parent){
                        if(item.parent.path == "/leistungen"){
                            active = true;
                        }
                    }
              })
          }
          return active
      }
  }
  
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/interface/NavBar/NavbarItem.vue